import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { HEADER } from "@/constants/testIds";
import { BRAND } from "@/data/site";

const NAV_ITEMS = [
  { to: "/", label: "Home" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/mini-shoots", label: "Mini-shoots" },
  { to: "/vrij-werk", label: "Vrij werk" },
  { to: "/over-eric", label: "Over Eric" },
  { to: "/contact", label: "Contact" },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  const solidHeader = scrolled || !isHome;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        solidHeader
          ? "bg-ink/85 backdrop-blur-md py-2"
          : "bg-transparent py-3"
      }`}
    >
      <div className="container-x flex items-center justify-between gap-6">
        <Link
          to="/"
          data-testid={HEADER.logo}
          className="flex items-center group shrink-0"
          aria-label="Lenslopers Fotografie"
        >
          <img
            src={BRAND.logoMark}
            alt="Lenslopers Fotografie"
            className={`transition-all duration-500 w-auto ${
              solidHeader ? "h-11 md:h-12" : "h-12 md:h-14"
            }`}
          />
        </Link>

        <nav
          data-testid={HEADER.nav}
          className="hidden lg:flex items-center gap-10"
        >
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`${HEADER.navLink}-${item.to.replace(/\//g, "") || "home"}`}
              className={({ isActive }) =>
                `text-[11px] uppercase tracking-[0.3em] transition-colors duration-300 ${
                  isActive ? "text-gold" : "text-white/90 hover:text-gold"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <button
          data-testid={HEADER.mobileToggle}
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-white p-2"
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid={HEADER.mobileMenu}
          className="lg:hidden bg-ink/95 backdrop-blur-md border-t border-white/10"
        >
          <div className="container-x py-6 flex flex-col gap-4">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `text-sm uppercase tracking-[0.25em] py-2 ${
                    isActive ? "text-gold" : "text-white/90"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
